import styled from '@emotion/styled';
import { Input } from '@chakra-ui/react';
import { themeColorPicker } from '../../../utils/themeSelectors';

export const StyledInput = styled(Input)`
  background: ${themeColorPicker('white')};
`;